function getCookie(name) {
  let cookieValue = null;

  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

/**
 * Host labels that are infrastructure or the public SMSP front door rather than a
 * tenant, and so all resolve to 'smsp'.
 *
 * Mirrors DEFAULT_TENANT_HOST_LABELS in django/utils/tenant_domains.py. Both sides
 * derive cookie names from the slug, so a label missing here makes the browser look
 * for sessionid_<label> while Django writes plain sessionid.
 */
const DEFAULT_TENANT_HOST_LABELS = [
  '', 'localhost', 'www', 'webapp', 'smsp', 'qa', 'api', 'localapi', 'stage', 'dev', 'beta',
];

/**
 * Extract tenant slug from current hostname.
 * Matches Django's get_tenant_slug_from_hostname logic.
 */
export function getTenantSlug() {
  if (typeof window === "undefined" || !window.location) {
    return 'smsp'; // Default fallback
  }

  const parts = window.location.hostname.toLowerCase().split('.');

  // Apex domain (and bare localhost / IP): no label to carry a tenant.
  if (parts.length < 3) {
    return 'smsp';
  }

  let subdomain = parts[0];

  // {tenant}.local.* and {tenant}.stage.* carry the tenant in the same leading label
  // as production, so they only differ in that 'local' is an environment marker here
  // rather than the legacy local{tenant} prefix.
  const envScoped = parts.length >= 4 && (parts[1] === 'local' || parts[1] === 'stage');
  if (!envScoped && subdomain.startsWith('local') && !DEFAULT_TENANT_HOST_LABELS.includes(subdomain)) {
    // Backwards compatibility: local{tenant}.strongmindstrongperformance.com
    subdomain = subdomain.substring('local'.length);
  }

  if (DEFAULT_TENANT_HOST_LABELS.includes(subdomain)) {
    return 'smsp';
  }

  return subdomain;
}

/**
 * Get tenant-specific CSRF cookie name.
 * Matches Django's get_tenant_csrf_cookie_name logic.
 * 
 * Note: tenantSlug is already cleaned by getTenantSlug() (removes 'local' prefix).
 */
function getTenantCSRFCookieName() {
  const tenantSlug = getTenantSlug();

  if (!tenantSlug || tenantSlug === 'smsp') {
    return 'csrftoken';
  }

  // Use tenant slug directly since it's already cleaned
  return `csrftoken_${tenantSlug}`;
}

export function getCSRFToken() {
  // Try tenant-specific cookie name first
  const tenantCookieName = getTenantCSRFCookieName();
  const tenantToken = getCookie(tenantCookieName);

  if (tenantToken) {
    return tenantToken;
  }

  // Fallback to default cookie name (for backwards compatibility or default tenant)
  const defaultCookieName = process.env.REACT_APP_CSRF_COOKIE_NAME || 'csrftoken';
  return getCookie(defaultCookieName);
}
